/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountAddress: { input: any; output: any; }
  CollectibleId: { input: any; output: any; }
  CollectionId: { input: any; output: any; }
  /**
   * A datetime with timezone offset.
   *
   * The input is a string in RFC3339 format, e.g. "2022-01-12T04:00:19.12345Z"
   * or "2022-01-12T04:00:19+03:00". The output is also a string in RFC3339
   * format, but it is always normalized to the UTC (Z) offset, e.g.
   * "2022-01-12T04:00:19.12345Z".
   */
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  /** A scalar that can represent any JSON value. */
  JSON: { input: any; output: any; }
  /** A scalar that can represent any JSON Object value. */
  JSONObject: { input: any; output: any; }
  Model421: { input: any; output: any; }
  Model443: { input: any; output: any; }
  OrderId: { input: any; output: any; }
  /**
   * A UUID is a unique 128-bit number, stored as 16 octets. UUIDs are parsed as
   * Strings within GraphQL. UUIDs are used to assign unique identifiers to
   * entities without requiring a central allocating authority.
   *
   * # References
   *
   * * [Wikipedia: Universally Unique Identifier](http://en.wikipedia.org/wiki/Universally_unique_identifier)
   * * [RFC4122: A Universally Unique IDentifier (UUID) URN Namespace](http://tools.ietf.org/html/rfc4122)
   */
  UUID: { input: any; output: any; }
  /** URL is a String implementing the [URL Standard](http://url.spec.whatwg.org/) */
  Url: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  address: Scalars['AccountAddress']['output'];
  /** List of coins that belongs to the [`Account`]. */
  coins: Scalars['JSONObject']['output'];
  /** List of collectibles that belongs to the [`Account`]. */
  collectibles: Array<Collectible>;
  /** List of collections that belongs to the [`Account`]. */
  collections: Array<Collection>;
};

/** Contains information needed to verify ownership of added account. */
export type AccountAddResponse = {
  __typename?: 'AccountAddResponse';
  /**
   * Information that should be signed.
   * Exact data depends on account type.
   */
  messageToSign: MessageToSign;
};

/**
 * Details of user's accounts.
 * Contains information about active accounts and their funds.
 */
export type Accounts = {
  __typename?: 'Accounts';
  /** List of active connected accounts. */
  accounts: Array<Account>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type AccountsFilter = {
  accounts?: InputMaybe<Array<Scalars['AccountAddress']['input']>>;
  askPriceMax?: InputMaybe<Scalars['Decimal']['input']>;
  askPriceMin?: InputMaybe<Scalars['Decimal']['input']>;
  chains?: InputMaybe<Array<Chain>>;
  collectionName?: InputMaybe<Scalars['String']['input']>;
  collectionsIds?: InputMaybe<Array<Scalars['CollectionId']['input']>>;
  properties?: InputMaybe<Array<AccountsFilterProperties>>;
};

export enum AccountsFilterProperties {
  Asked = 'ASKED',
  Bidded = 'BIDDED',
  Spam = 'SPAM'
}

export type AssetsFilter = {
  chains?: InputMaybe<Array<Chain>>;
  collectionsIds?: InputMaybe<Array<Scalars['CollectionId']['input']>>;
  properties?: InputMaybe<Array<AssetsFilterProperties>>;
};

export enum AssetsFilterProperties {
  Asked = 'ASKED',
  Bidded = 'BIDDED',
  Spam = 'SPAM'
}

export type AuthSignature = {
  body?: InputMaybe<Scalars['Model443']['input']>;
  signature: Scalars['String']['input'];
};

/**
 * Enumeration of supported chains. Variants will be used in addresses of other entities such as:
 * - [`crate::tokens::coins::Coins`]
 */
export enum Chain {
  Aptos = 'APTOS',
  Ethereum = 'ETHEREUM',
  Polygon = 'POLYGON'
}

export type Collectible = {
  __typename?: 'Collectible';
  animationUrl?: Maybe<Scalars['Url']['output']>;
  collection?: Maybe<Collection>;
  description: Scalars['String']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['CollectibleId']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  lastSalePrice?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orders: Array<OrderItemDetails>;
  tokenId: Scalars['String']['output'];
  url?: Maybe<Scalars['Url']['output']>;
};

export type Collection = {
  __typename?: 'Collection';
  bannerImageUrl?: Maybe<Scalars['Url']['output']>;
  description: Scalars['String']['output'];
  floorPrice: Scalars['String']['output'];
  id: Scalars['CollectionId']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  url?: Maybe<Scalars['Url']['output']>;
};

/** Cursor related inputs. */
export type CursorInput = {
  /** Optional cursor name. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Limit number of items per page. */
  limit: Scalars['Int']['input'];
};

/** Sorting direction. */
export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** [EIP-712](https://eips.ethereum.org/EIPS/eip-712) signature. */
export type Eip712Signature = {
  /** Signature hex representation. */
  signature: Scalars['String']['input'];
};

/** [EIP-1271](https://eips.ethereum.org/EIPS/eip-1271) signature. */
export type Eip1271Signature = {
  /**
   * Hash of the data that was signed.
   * Hex representation of [`primitivie_types::H256`]
   */
  hash: Scalars['String']['input'];
  /** Signature hex representation. */
  signature: Scalars['String']['input'];
  /**
   * Ethereum address of deployed smart wallet contract to call for signature verification.
   * Hex representation of [`primitive_types::H160`]
   */
  smartWalletContractAddress: Scalars['String']['input'];
};

export type FeasibilityResponse = {
  __typename?: 'FeasibilityResponse';
  orderId: Scalars['UUID']['output'];
  origin: Scalars['JSON']['output'];
  provider: Provider;
};

/** Composition of all possible signature variants. */
export type MessageToSign = PetraMessageToSign | SimpleMessageToSign;

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Add new unverified account to a list of accounts of the current user.
   *
   * # Errors
   *
   * This function will return an error if system error occurs.
   */
  accountAdd: AccountAddResponse;
  /**
   * Remove account from a user. Returns `true` if account was removed and `false` otherwise.
   *
   * # Errors
   *
   * This function will return an error if system error occurs.
   */
  accountRemove: Scalars['Boolean']['output'];
  /**
   * Verify unverified account of the current user. Returns `true` if succeed and `false` otherwise.
   *
   * # Errors
   *
   * This function will return an error if system error occurs.
   */
  accountVerify: Scalars['Boolean']['output'];
  /**
   * Hide collectibles from user's profile.
   *
   * # Errors
   *
   * This function will return an error if system error occurs.
   */
  collectiblesHide: Scalars['Boolean']['output'];
  /**
   * Show previously hidden collectibles in user's profile.
   *
   * # Errors
   *
   * This function will return an error if system error occurs.
   */
  collectiblesShow: Scalars['Boolean']['output'];
  executeStep: StepResponse;
  /**
   * Cancel existing order if it is not filled yet.
   *
   * # Errors
   * Returns error if order is in a wrong state, not found or if underlying system error occurs.
   */
  orderCancel: Scalars['Boolean']['output'];
  prepare: FeasibilityResponse;
  submitTransaction: Scalars['Boolean']['output'];
  /**
   * Will set yats to hidden based on list of eids if present, otherwise it will set all yats to hidden. Primary yat
   * will never be set.
   *
   * # Errors
   *
   * This function will return an error if system error occurs.
   */
  yatsHide: Scalars['Boolean']['output'];
  /**
   * Will set yats to visible based on list of eids if present, otherwise it will set all yats to visible. Primary
   * yat will never be set.
   *
   * # Errors
   *
   * This function will return an error if system error occurs.
   */
  yatsShow: Scalars['Boolean']['output'];
};


export type MutationAccountAddArgs = {
  accountAddress: Scalars['AccountAddress']['input'];
  accountPublicKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAccountRemoveArgs = {
  accountAddress: Scalars['AccountAddress']['input'];
};


export type MutationAccountVerifyArgs = {
  address: Scalars['AccountAddress']['input'];
  publicKey: Scalars['String']['input'];
  signature: Signature;
};


export type MutationCollectiblesHideArgs = {
  collectiblesIdsToHide: Array<Scalars['CollectibleId']['input']>;
};


export type MutationCollectiblesShowArgs = {
  collectiblesIdsToShow: Array<Scalars['CollectibleId']['input']>;
};


export type MutationExecuteStepArgs = {
  orderId: Scalars['UUID']['input'];
  step: Step;
};


export type MutationOrderCancelArgs = {
  orderItemId: Scalars['OrderId']['input'];
};


export type MutationPrepareArgs = {
  request: NewOrder;
};


export type MutationSubmitTransactionArgs = {
  orderId: Scalars['UUID']['input'];
  signedTransaction: Scalars['JSON']['input'];
};


export type MutationYatsHideArgs = {
  eids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationYatsShowArgs = {
  eids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NewOrder = {
  account: Scalars['AccountAddress']['input'];
  allMarkets: Scalars['Boolean']['input'];
  chain: Chain;
  /** Date and time in UTC offset when order should expire if not filled. */
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<NewOrderItem>;
  side: Side;
  type: OrderType;
};

export type NewOrderItem = {
  collectibleIdentifier: Scalars['CollectibleId']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
  quantity: Scalars['Decimal']['input'];
};

export type Order = {
  __typename?: 'Order';
  account: Scalars['String']['output'];
  chain: Chain;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  side: Side;
  status: OrderStatus;
  type: OrderType;
  userId: Scalars['UUID']['output'];
};

/** Order related inputs. */
export type OrderInput = {
  direction: Direction;
  field: Scalars['String']['input'];
};

export type OrderItemDetails = {
  __typename?: 'OrderItemDetails';
  account: Account;
  chain: Chain;
  collectible?: Maybe<Collectible>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['OrderId']['output']>;
  oppositeAddress?: Maybe<Account>;
  price?: Maybe<Scalars['Decimal']['output']>;
  quantity: Scalars['Decimal']['output'];
  side: Side;
  status: OrderStatus;
  type: OrderType;
  userId: Scalars['UUID']['output'];
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Failed = 'FAILED',
  New = 'NEW',
  Pending = 'PENDING'
}

export enum OrderType {
  Limit = 'LIMIT',
  LimitMaker = 'LIMIT_MAKER',
  Market = 'MARKET',
  StopLoss = 'STOP_LOSS',
  StopLossLimit = 'STOP_LOSS_LIMIT',
  TakeProfit = 'TAKE_PROFIT',
  TakeProfitLimit = 'TAKE_PROFIT_LIMIT'
}

export type OrderUpdate = {
  __typename?: 'OrderUpdate';
  orderId: Scalars['UUID']['output'];
  orderStatus: OrderStatus;
};

export type PetraMessageToSign = {
  __typename?: 'PetraMessageToSign';
  /** Should we include the address of the account in the message */
  includeAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Should we include the domain of the dapp */
  includeApplication?: Maybe<Scalars['String']['output']>;
  /** Should we include the current chain id the wallet is connected to */
  includeChainId?: Maybe<Scalars['Boolean']['output']>;
  /** The message to be signed and displayed to the user */
  message: Scalars['String']['output'];
  /** A nonce the dapp should generate */
  nonce: Scalars['String']['output'];
};

/** [Petra](https://petra.app/docs/signing-a-message) signature. */
export type PetraSignature = {
  /** Hex representation of [`crate::accounts::AptosAddress`] */
  address: Scalars['String']['input'];
  application: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
  /** The message that was generated to sign */
  fullMessage: Scalars['String']['input'];
  /** The message passed in by the user */
  message: Scalars['String']['input'];
  nonce: Scalars['String']['input'];
  /** Should always be APTOS */
  prefix: Scalars['String']['input'];
  /** The signed full message */
  signature: Scalars['String']['input'];
};

export type PostAuthSignatureV1Response = {
  __typename?: 'PostAuthSignatureV1Response';
  auth?: Maybe<Scalars['String']['output']>;
};

export type PostOrderV2Response = {
  __typename?: 'PostOrderV2Response';
  /** Only available when posting to external orderbook. Can be used to retrieve the status of a cross-post order. */
  crossPostingOrderId?: Maybe<Scalars['String']['output']>;
  crossPostingOrderStatus?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
};

export enum Provider {
  Reservoir = 'RESERVOIR',
  YatAptosMarketplace = 'YAT_APTOS_MARKETPLACE'
}

export type Query = {
  __typename?: 'Query';
  /**
   * Load all accounts of the specified user or unauthenticated request.
   *
   * # Errors
   *
   * This function will return an error if system error occurs.
   */
  accounts: Accounts;
  collectibles: Array<Collectible>;
  orderUpdates: Array<Order>;
  /**
   * Query all orders with different filters. This is a base query you should use if needed information about
   * orders.
   */
  orders: Array<OrderItemDetails>;
  /**
   * Will list all yats of user if endpoint was called by owner. Any other users calling this endpoint will only see
   * yats of someone else that had previously been set to visible.
   *
   * # Errors
   *
   * This function will return an error if system error occurs.
   */
  yats: Array<Yat>;
};


export type QueryAccountsArgs = {
  accountsFilter?: InputMaybe<AccountsFilter>;
  cursorInput?: InputMaybe<CursorInput>;
  userFilter?: InputMaybe<UserFilterInput>;
};


export type QueryCollectiblesArgs = {
  assetsFilter?: InputMaybe<AssetsFilter>;
  ids?: InputMaybe<Array<Scalars['CollectibleId']['input']>>;
  orderInput?: InputMaybe<OrderInput>;
};


export type QueryOrdersArgs = {
  collectibles?: InputMaybe<Array<Scalars['CollectibleId']['input']>>;
  ordersIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  side?: InputMaybe<Side>;
  userFilter?: InputMaybe<UserFilterInput>;
};


export type QueryYatsArgs = {
  userFilter?: InputMaybe<UserFilterInput>;
  yatsFilter?: InputMaybe<YatsFilterInput>;
};

export enum Side {
  Ask = 'ASK',
  Bid = 'BID'
}

/** Different types of supported signatures. */
export type Signature = {
  /** Different types of supported signatures. */
  eip712?: InputMaybe<Eip712Signature>;
  /** Different types of supported signatures. */
  eip1271?: InputMaybe<Eip1271Signature>;
  /** Different types of supported signatures. */
  petra?: InputMaybe<PetraSignature>;
};

export type SimpleMessageToSign = {
  __typename?: 'SimpleMessageToSign';
  /** The message to be signed and displayed to the user. */
  message: Scalars['String']['output'];
};

export type Step = {
  authSignature?: InputMaybe<AuthSignature>;
  submitOrder?: InputMaybe<SubmitOrder>;
};

export type StepResponse = PostAuthSignatureV1Response | PostOrderV2Response;

export type SubmitOrder = {
  body?: InputMaybe<Scalars['Model421']['input']>;
  signature: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  ordersUpdates: Array<OrderUpdate>;
};

export type UserFilterInput = {
  current?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type Yat = {
  __typename?: 'Yat';
  eid: Scalars['String']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Scalars['JSON']['output']>;
  minted?: Maybe<Scalars['Boolean']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  rhythmScore?: Maybe<Scalars['Int']['output']>;
};

export type YatsFilterInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddConnectedWalletMutationVariables = Exact<{
  accountPublicKey?: InputMaybe<Scalars['String']['input']>;
  accountAddress: Scalars['AccountAddress']['input'];
}>;


export type AddConnectedWalletMutation = { __typename?: 'Mutation', accountAdd: { __typename?: 'AccountAddResponse', messageToSign: { __typename?: 'PetraMessageToSign', message: string, includeAddress?: boolean | null, includeChainId?: boolean | null, includeApplication?: string | null, nonce: string } | { __typename?: 'SimpleMessageToSign', message: string } } };

export type RemoveConnectedWalletMutationVariables = Exact<{
  accountAddress: Scalars['AccountAddress']['input'];
}>;


export type RemoveConnectedWalletMutation = { __typename?: 'Mutation', accountRemove: boolean };

export type AccountVerifyMutationVariables = Exact<{
  address: Scalars['AccountAddress']['input'];
  publicKey: Scalars['String']['input'];
  signature: Signature;
}>;


export type AccountVerifyMutation = { __typename?: 'Mutation', accountVerify: boolean };

export type HideAccountsCollectiblesMutationVariables = Exact<{
  collectiblesIdsToHide: Array<Scalars['CollectibleId']['input']> | Scalars['CollectibleId']['input'];
}>;


export type HideAccountsCollectiblesMutation = { __typename?: 'Mutation', collectiblesHide: boolean };

export type ShowAccountsCollectiblesMutationVariables = Exact<{
  collectiblesIdsToShow: Array<Scalars['CollectibleId']['input']> | Scalars['CollectibleId']['input'];
}>;


export type ShowAccountsCollectiblesMutation = { __typename?: 'Mutation', collectiblesShow: boolean };

export type ExecuteStepMutationVariables = Exact<{
  orderId: Scalars['UUID']['input'];
  step: Step;
}>;


export type ExecuteStepMutation = { __typename?: 'Mutation', executeStep: { __typename?: 'PostAuthSignatureV1Response', auth?: string | null } | { __typename?: 'PostOrderV2Response', message?: string | null, orderId?: string | null, crossPostingOrderId?: string | null, crossPostingOrderStatus?: string | null } };

export type CancelOrderMutationVariables = Exact<{
  orderItemId: Scalars['OrderId']['input'];
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', orderCancel: boolean };

export type PrepareOrderMutationVariables = Exact<{
  request: NewOrder;
}>;


export type PrepareOrderMutation = { __typename?: 'Mutation', prepare: { __typename?: 'FeasibilityResponse', orderId: any, provider: Provider, origin: any } };

export type PrepareMutationVariables = Exact<{
  type: OrderType;
  side: Side;
  account: Scalars['AccountAddress']['input'];
  chain: Chain;
  items: Array<NewOrderItem> | NewOrderItem;
  allMarkets: Scalars['Boolean']['input'];
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type PrepareMutation = { __typename?: 'Mutation', prepare: { __typename?: 'FeasibilityResponse', orderId: any, provider: Provider, origin: any } };

export type HideAccountYatsMutationVariables = Exact<{
  eids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type HideAccountYatsMutation = { __typename?: 'Mutation', yatsHide: boolean };

export type ShowAccountYatsMutationVariables = Exact<{
  eids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ShowAccountYatsMutation = { __typename?: 'Mutation', yatsShow: boolean };

export type GetAccountsQueryVariables = Exact<{
  userFilter?: InputMaybe<UserFilterInput>;
  accountsFilter?: InputMaybe<AccountsFilter>;
  cursorInput?: InputMaybe<CursorInput>;
}>;


export type GetAccountsQuery = { __typename?: 'Query', accounts: { __typename?: 'Accounts', cursor?: string | null, accounts: Array<{ __typename?: 'Account', address: any, coins: any, collections: Array<{ __typename?: 'Collection', id: any, name: string, slug: string, description: string, imageUrl?: any | null, bannerImageUrl?: any | null, url?: any | null, floorPrice: string }>, collectibles: Array<{ __typename?: 'Collectible', id: any, name: string, description: string, tokenId: string, imageUrl?: any | null, animationUrl?: any | null, url?: any | null, hidden?: boolean | null, lastSalePrice?: string | null, orders: Array<{ __typename?: 'OrderItemDetails', id?: any | null, account: { __typename?: 'Account', address: any } }>, collection?: { __typename?: 'Collection', id: any, name: string, slug: string, description: string, imageUrl?: any | null, bannerImageUrl?: any | null, url?: any | null, floorPrice: string } | null }> }> } };

export type GetCollectiblesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['CollectibleId']['input']> | Scalars['CollectibleId']['input']>;
  assetsFilter?: InputMaybe<AssetsFilter>;
  orderInput?: InputMaybe<OrderInput>;
}>;


export type GetCollectiblesQuery = { __typename?: 'Query', collectibles: Array<{ __typename?: 'Collectible', id: any, name: string, description: string, tokenId: string, imageUrl?: any | null, animationUrl?: any | null, url?: any | null, hidden?: boolean | null, lastSalePrice?: string | null, orders: Array<{ __typename?: 'OrderItemDetails', id?: any | null }>, collection?: { __typename?: 'Collection', id: any, name: string } | null }> };

export type GetCurrentUserOrdersQueryVariables = Exact<{
  userFilter?: InputMaybe<UserFilterInput>;
}>;


export type GetCurrentUserOrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'OrderItemDetails', id?: any | null, type: OrderType, userId: any, side: Side, chain: Chain, status: OrderStatus, price?: any | null, quantity: any, createdAt: any, expiresAt?: any | null, account: { __typename?: 'Account', address: any }, collectible?: { __typename?: 'Collectible', id: any, name: string, description: string, tokenId: string, imageUrl?: any | null, animationUrl?: any | null, url?: any | null, hidden?: boolean | null, lastSalePrice?: string | null, orders: Array<{ __typename?: 'OrderItemDetails', id?: any | null }>, collection?: { __typename?: 'Collection', id: any, name: string, slug: string, floorPrice: string, imageUrl?: any | null, description: string, url?: any | null } | null } | null, oppositeAddress?: { __typename?: 'Account', address: any } | null }> };

export type GetUserYatsQueryVariables = Exact<{
  userFilter?: InputMaybe<UserFilterInput>;
  yatsFilter?: InputMaybe<YatsFilterInput>;
}>;


export type GetUserYatsQuery = { __typename?: 'Query', yats: Array<{ __typename?: 'Yat', eid: string, media?: any | null, hidden?: boolean | null, minted?: boolean | null, rhythmScore?: number | null, primary?: boolean | null }> };


export const AddConnectedWalletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddConnectedWallet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountPublicKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountAddress"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountAdd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountPublicKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountPublicKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountAddress"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageToSign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleMessageToSign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PetraMessageToSign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"includeAddress"}},{"kind":"Field","name":{"kind":"Name","value":"includeChainId"}},{"kind":"Field","name":{"kind":"Name","value":"includeApplication"}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddConnectedWalletMutation, AddConnectedWalletMutationVariables>;
export const RemoveConnectedWalletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveConnectedWallet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountAddress"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountAddress"}}}]}]}}]} as unknown as DocumentNode<RemoveConnectedWalletMutation, RemoveConnectedWalletMutationVariables>;
export const AccountVerifyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountVerify"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountAddress"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signature"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Signature"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountVerify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"publicKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"signature"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signature"}}}]}]}}]} as unknown as DocumentNode<AccountVerifyMutation, AccountVerifyMutationVariables>;
export const HideAccountsCollectiblesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HideAccountsCollectibles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectiblesIdsToHide"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectibleId"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectiblesHide"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectiblesIdsToHide"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectiblesIdsToHide"}}}]}]}}]} as unknown as DocumentNode<HideAccountsCollectiblesMutation, HideAccountsCollectiblesMutationVariables>;
export const ShowAccountsCollectiblesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShowAccountsCollectibles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectiblesIdsToShow"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectibleId"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectiblesShow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectiblesIdsToShow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectiblesIdsToShow"}}}]}]}}]} as unknown as DocumentNode<ShowAccountsCollectiblesMutation, ShowAccountsCollectiblesMutationVariables>;
export const ExecuteStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExecuteStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"step"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Step"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executeStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"step"},"value":{"kind":"Variable","name":{"kind":"Name","value":"step"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostOrderV2Response"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"crossPostingOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"crossPostingOrderStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostAuthSignatureV1Response"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth"}}]}}]}}]}}]} as unknown as DocumentNode<ExecuteStepMutation, ExecuteStepMutationVariables>;
export const CancelOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderItemId"}}}]}]}}]} as unknown as DocumentNode<CancelOrderMutation, CancelOrderMutationVariables>;
export const PrepareOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepareOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewOrder"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepare"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}}]}}]}}]} as unknown as DocumentNode<PrepareOrderMutation, PrepareOrderMutationVariables>;
export const PrepareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Prepare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"side"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Side"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountAddress"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Chain"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewOrderItem"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allMarkets"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expirationTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepare"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"side"},"value":{"kind":"Variable","name":{"kind":"Name","value":"side"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"chain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allMarkets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allMarkets"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expirationTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expirationTimestamp"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}}]}}]}}]} as unknown as DocumentNode<PrepareMutation, PrepareMutationVariables>;
export const HideAccountYatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HideAccountYats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yatsHide"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eids"}}}]}]}}]} as unknown as DocumentNode<HideAccountYatsMutation, HideAccountYatsMutationVariables>;
export const ShowAccountYatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShowAccountYats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yatsShow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eids"}}}]}]}}]} as unknown as DocumentNode<ShowAccountYatsMutation, ShowAccountYatsMutationVariables>;
export const GetAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursorInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CursorInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountsFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountsFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursorInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursorInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"coins"}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"floorPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tokenId"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"animationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"lastSalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"floorPrice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<GetAccountsQuery, GetAccountsQueryVariables>;
export const GetCollectiblesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollectibles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectibleId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetsFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetsFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tokenId"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"animationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"lastSalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCollectiblesQuery, GetCollectiblesQueryVariables>;
export const GetCurrentUserOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"collectible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tokenId"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"animationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"lastSalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"floorPrice"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"oppositeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserOrdersQuery, GetCurrentUserOrdersQueryVariables>;
export const GetUserYatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserYats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yatsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"YatsFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"yatsFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yatsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eid"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"minted"}},{"kind":"Field","name":{"kind":"Name","value":"rhythmScore"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<GetUserYatsQuery, GetUserYatsQueryVariables>;